import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface DefaultCSSStyle extends UIComponentCSSStyle
{
    
}

export class DefaultCSSStyleImpl extends UIComponentCSSStyleImpl implements DefaultCSSStyle
{   
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/default/defaultcss.tsx